export var LinkedBpApplicationsHeadingEnum;
(function (LinkedBpApplicationsHeadingEnum) {
    LinkedBpApplicationsHeadingEnum["id"] = "Id";
    LinkedBpApplicationsHeadingEnum["referenceNumber"] = "Reference number";
    LinkedBpApplicationsHeadingEnum["applicationType"] = "Application type";
    LinkedBpApplicationsHeadingEnum["description"] = "Description";
    LinkedBpApplicationsHeadingEnum["applicant"] = "Applicant";
    LinkedBpApplicationsHeadingEnum["createdDate"] = "Created date";
    LinkedBpApplicationsHeadingEnum["startedDate"] = "Started date";
    LinkedBpApplicationsHeadingEnum["status"] = "Status";
    LinkedBpApplicationsHeadingEnum["linked"] = "Application linked";
    LinkedBpApplicationsHeadingEnum["links"] = "Navigate to application";
})(LinkedBpApplicationsHeadingEnum || (LinkedBpApplicationsHeadingEnum = {}));
export const LinkedBpApplicationsHeadingEnumLookup = new Map([
    [LinkedBpApplicationsHeadingEnum.referenceNumber, "referenceNumber"],
    [LinkedBpApplicationsHeadingEnum.applicationType, "applicationType"],
    [LinkedBpApplicationsHeadingEnum.description, "description"],
    [LinkedBpApplicationsHeadingEnum.applicant, "applicant"],
    [LinkedBpApplicationsHeadingEnum.createdDate, "createdDate"],
    [LinkedBpApplicationsHeadingEnum.startedDate, "startedDate"],
    [LinkedBpApplicationsHeadingEnum.status, "status"],
    [LinkedBpApplicationsHeadingEnum.linked, "linked"]
]);
